import { FullWidthSection, ContentContainer } from 'components/layout/'
import React from 'react'
import styled from 'styled-components'

import { LandingPageOptions } from 'components/layout/Providers'
import CarouselSection from './CarouselSection/CarouselSection'
import TopicGrid from './TopicGrid/TopicGrid'

const FullWidthSectionWithMargin = styled(FullWidthSection)`
  margin-bottom: 6rem;
`
interface LandingOptionsProps {
  exploreSection: LandingPageOptions
}
const LandingOptions = ({ exploreSection }: LandingOptionsProps) => {
  // render nothing if desired
  if (exploreSection === 'none') {
    return <></>
  }
  // otherwise, render grid or carousel
  return (
    <FullWidthSectionWithMargin>
      <ContentContainer>
        {exploreSection === 'grid' ? <TopicGrid /> : <CarouselSection />}
      </ContentContainer>
    </FullWidthSectionWithMargin>
  )
}

export default LandingOptions
